<template>
    <div
        id="lt-yantr"
        class="debt-relief debt-relief-2 yantr-tracking">
        <div class="container-fluid fadeInBlock text-center yantr-bullseye">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12 col-md-10 glob-marg">
                        <form>
                            <div class="row">
                                <div class="col-xs-12 col-md-4">
                                    <number-input
                                        v-model="Amount"
                                        :label="labelDebtAmount"
                                        inputmode="decimal"
                                    />
                                </div>
                                <div class="col-xs-12 col-md-4">
                                    <drop-down
                                        v-model="State"
                                        :label="labelStates"
                                        :options="StateList"
                                    />
                                </div>
                                <div class="col-xs-12 col-md-4">
                                    <button
                                        class="btn btn-blue"
                                        type="button"
                                        @click="isButtonClicked(); getDetails()">
                                        {{ ButtonText }}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div id="medium-bullseye">
            <transition
                v-if="!ShowLoader"
                name="fade">
                <div class="loader">
                    <img
                        alt="lt-loader"
                        width="61"
                        height="60"
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAA8CAYAAADVPrJMAAAAAXNSR0IArs4c6QAADJZJREFUaAXdWwtwVcUZ/nfPuffc5JKHgBDESkBR0VpRREWhBEJDo6A4TlIFywRQbEWccZSiaDu3voa21s5A1QoFEh6lhtYHKD5ISCoy+AIERitiykAECUoIuYTknnN2t9+eJBDIDbkhEXOzk9xz7p49u/+3/3P/3cvo+yrvqCDVVATJCF5KjjuEuBpMitKJsTRcg8RUEhE7ivtjIOEAkdpLxLcRE1vJsnbQgdoamtrzKNqrjiaRdWiHhQe7AdwAYr7hIDYLoG4gRuceH4Pp4fDfeAVirygJzE2wSXkEjz4gMt8lEiVkVO2m2/pXHe+nnTcdA7qwvDv5U24kV9xKnMZRINibXLseCDeIDBNkYqg6MJXJGpIUwVcXlXhIfgBMooRgPRSJaiHq2/v8eKfmMDpaCyl4HX1uoNxekIr2lfaBXgQRTTk8iTi7G2iuIiuBe2A1TRqsXfc1uPoRAH5KQu4kZlRCfGtwtcmxBRl+DoR+klAFzs4hyS7Gm1eQwYaS6b+wnvuQAhPgbUwik9tJqKVUkbqY7mOYjDMrZwRahcDP82jcu8kZD2f7X7tEWom9SIAoISQpeRjEr8J1NZnsvyCriiakVgM8qG+tKEbLKzGRLJVq+UVkqnGk2J0YrRcmkZNpEY9Uh2/uNv/ljNTlTzx0bVl5az1Ge95m0GoxdDSRZkMkZ9awoPmw8Xv3b8YM9B0pI0EFpMLLic4/QLlMy2j7SqGCuHzVnYyekCa6h1jCgCG+f1VkBZekci6rIAmP+YLhV0PXbNbGMObSJtBqBQ0kkxaCgJHeCCDpQ/eaz65nRfnkpOTTRPZdzCO3teErqofJDuZNTp7zcHq3sjTbMSBMygXwBYI7j88d8X7M4h4zaAC+lXz0J5iegeAowRjVgdt/oUpaxmaQFuPvvcC+89+tHzZCGImzuEk3a4MPoYe6q/cU4/f/YWTRjliIiAm0+gfdDmP0V9jZNA+woP0A/CC4/hrLJSjz2S1zijJ7kylnwAI8whnzcR/sZ0Rss5SZFxq17tPWqGkVNACPhzgvAEAdVGgOfwSH8wCbTB+21vn3+TxUkmE6jOdIRs8ZJkvTQKSjPou4bOKzY4q3n27s04KGSI+BSP8doPt5nbi0Bdc72R305ek6PZvP5pRmjoIrW2H4jD4KXFGO2sKI3/XUyKIWVQ4aEb3AG8JN0LPQ4X4ehx3ajut9nQmwpvyZjOISqdgMYcsKSKF2/VcLJebNXHtdcnRkMAzRHgBwEBx+Fjp8pRc3ufQVdPoOeMwfVKSj0arr5masfxWyPUm66pBwJWIZY0xSMDhn5tpsK9o7UUED8B3Q4Ts9o6WoBlNzPzjcorhE6/hs1z0zekOxYvIhKRD7CYWgjx5ITIwg/m9emoGGHmv9DUGUTYi2C5F5AnDXNX+189UcrUn4J+A+hwgYhp0lcEZzH12bfWLB00ByM9AAOhuc7QvICLLoDcDOZyGtLZ2/zL/prYjBnPnCkRu4AdiMBqmEyEOnUn4SaLWSMsHhXwAwI4cO4XMuXNPBU1/qzN+fHvleuSvoCSHVEcPkDNzOm108+oamNJ8EGg+mwnhhtYM7SevhmTc3bRwv97V1gfelIz8G04j7WS+m4/Ym5ThotYwuQaPheMZgwCoBegEb5dnuJs3j41aLuZTGQgQr1RwhG7id8fh/fjawkXoPNAItBpEeBqt9gQdT0WY2iYoaG8Xjde7oolWw4luFo7TvTpfkDmvEUc/pQtKOPFOLgxeIKFra2CBer4CCRZhajA/SrGaksmZ/MiZF46kHHaF01I5rEOZ9WPa/Ga9gm9IdYYdXA+BeiYBFKj5ehln/E6ADNIgsSm3gdBH1pOqmL8fr/Q3fDgzDiq/TeUh/gpFskDPYA60KYa8l9FlbbM13WG0sF9uf9egEM5WbuwqxGUBDvHWUBjm/ceaubItjNRyAHg/2QEPbEZxs6wT0dhgJzDB2uLaMKGQcwPEhfY84AQ7uItWIDCREAPzdhQmo7LARO0FHoo5XKZLbGRAD4qDwITsZGUZPl89p0Oc9AF3bCWjtMBJYd1UDT12m9RpBSkD6jPO0Fvf1RtCcJqoA5Ih310U+jh301cF7faP1WrtjpdgFGjRSrPj04Z/TEfw7XQSvB2Ne9lobQCv13gM4jUSi7M0pDLi19A0d9bh8COmDuFhRxcoYLyyxVU2kBknTOqp1pJliUrEfTEfhuLiQfL1T0cXKoQNYbWGpLLQMGwq31ToOY32wfwTQ1AP7F1rku1RxXOW3DOaXSJ26QlVxZBK/9Sy3Z8jUORBy7cK6TMlZdbkPMWj3enHWjJaHYcTNfUCos6e6Jg2fUZNp8ToLSeFUCy6rt7fwAGO5lHuxNeCrBuD6PSjF0slMSIhXgNHorpWBRMZVumeelXKFwwFahG2Id/0eEGP9yXCbJdKidRYvdZbJk+GyBmtRxoGHMlu5Rzjtw0Yc0VYPBNP5T+PqeAEUG53uQNPHk3XgrTjf4vREYMo262BEbWoIQ9GPzFQZXi40tj47catQKIRkkRrl7W7q7KhQGy//fFOk0T19AXdV4dHPkBlLQjzeBcr+PmsCJPlN2ogJVx1zyd0SCqHGwxa294DTbzR4aOi0dXsXwEy2PzkDq6tLdQ7cFbLESEr8SuPyQLNSBKGk1ntuy4vb6C69/Ix34FzxKQCNcAzoGL3V7/PrDh0H7YGT9gcAXeZB5Vhf3+K/JZ5B5y0ccz2A/tTjckRWMCU2Qse9dUWjThN7k/4H0KXasgN4CqzdPSonPqOznJwcgxnq18h59/KYKGlTfl7p8YzQcdAeVx2xCJAbtnHUjVRrnrQdEi+ct37+3Y/hocZ6XLZFGOuofIBvjERPXlywt91NOJxWgOhF4TAbLDj7rbol8bx4AavpnFY4truf81mmz+gNi62V+dWCKUWrm2I4mdP6iWk/B8i7vLDN5Bmk3BlqupdiaPpep713joqJOHiTI/U5PiUPHBP0tI5LmhLcDDRbDX8t1GNoFAFw/XwW7UuY0PSlzno/ZXHWaJOpJ0G/H+IssIR88uXpxV+eSm8z0F6DKvtNzM0CzwjgSC+Wn/PUBN+1p77cmb7nLcm6FAmB5+GiUrmJPLdLr1hBsTQajS36YjUBUZmw1iAaH+6JuqLdmIR72erIumgd/ZB10wpGX6sEWwCwVzIdiNhyB2KwrPwppVFPDEfnNBCw17CjxeSDEJUvPI5z6o/F+AvqZt+QHxLgqWNPLsi8GFL5guFjV2o6cQqh3FVyVkuA9fstgtYP2WrnEwC/G5zerb/Dol8E/71SjTezYBlalBKv7Vn4mLwoc5gpaAXj3GMEThdVQKwfWDa15N3TDR8T4SrbHInc6WLk0QZ4ok4KG3zqURxjWomgJuaDqKcjpC3Pfrk0K2gq+zYmjT8iyOyj/TE4/I2QbGbBtKJ/t9ZXTKB1J2p8wnCswudDx+v3vbxKHKJk9ny2Rv/04OyUyQUjfmII369gsKYDsKEBSyl3Kil/sziv5CR/3BJFMYPWHaixiX3Icp+Hw7/N69Bw6KActP9temSFKfnCSW9M2tXSQO2tf3Hci31TVNL0LcPfmXo4ff/5ZIN0/CkhiwUMbEHe+rJYx2gTaN2pZ9VdCwfOxWM2BYMfsonObj48wJVTjgX76zAqC/3+PTtzV4XsWIloqd1L01/ysW8D/f1C5CGOzjWlkf5dr69rPxuy0bITah0laF7ElX9eeW9pm86Ztxm0B1zP8Vgautc39PFS4/6hAdNMk0hA4ageMKtjUIMSpsxXTINtkiJSaVop1bmrclvdGFySsSQQPFclhcOqO6KqIT6DT8AWazYiqqCWY71GxE8/qj6/ZsPW8h/tfOrCve+V6qRAS5PWUv0ZgT7RmTKWTVg0HptEMzEPQwNGIMmVDjybDt1BoHDqsDzfjBw7VjjyCyb5PsnlUS5YBL/PENhRMaCbfrRPhJT0wVRehjw0FgtyqI/7u+FgK5wFzgBhTyLiRCIg9hNHipfS10xbOYoYNinOrLQTdP2ghTmF/mOR6usZM8aiw1v9hv9yKALAS49oPQHeSh7NbWwbSYmlAAwuJkQfgfFZBlLteFG31/96A12314DRfhdq13DJ37as4CZIDBIe7SsdArqRhFBI8Qu3LB+AXNRVJkdCjvgIQLkMkE/EAxgRQBtf0eqg56dp0aeCdsEmb5SMredSfVxmle8OdYCNaBzkxOiNNR10nZc9z+rBeySGWbhnIreuALKrwL5+hmRpilM3cC+JKfzskMEGSKqQTO3BCaBthmFss027wggax6bkT9Hp6Q4v/weSyMev44VhewAAAABJRU5ErkJggg=="
                    />
                </div>
            </transition>
            <div
                v-if="ApiResponse.length == 0 && ShowLoader"
                class="container offers-container">
                <div class="row">
                    <div class="col-xs-12">
                        No offers found.
                    </div>
                </div>
            </div>
            <div v-else>
                <debt-relief-offers
                    v-if="ShowLoader"
                    :contact-btn-text="contactBtnText"
                    :api-response="ApiResponse"
                    :amount="Amount"
                    :state="State"
                    :lead-guid="LeadGuid"
                    :hide-hdltgp="hideHdltgp"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import { find } from 'lodash-es';
    import { getPrePrimeDetails, postPrePrimeLead } from '~/services/preprime-api';
    import NumberInput from '~/components/number-input.vue';
    import DropDown from '~/components/drop-down.vue';
    import States from '~/constants/states';
    import DebtReliefOffers from '~/components/debt-relief-offers-2.vue';
    import ScrollToElement from '~/helpers/scroll-to-element';
    import TrackDataHelper from '~/helpers/track-data-helper';
    import AnalyticsTrack from '~/mixin/analytics-track';
    import AnalyticsHelper from '~/helpers/analytics';
    import SessionIdHelper from '~/helpers/uuid-service';
    import appStorage from '~/helpers/app-storage';
    import QueryStringHelper from '~/helpers/query-string-helper';

    export default {
        components: {
            DropDown,
            NumberInput,
            DebtReliefOffers,
        },
        mixins: [AnalyticsTrack],
        props: {
            amount: {
                default: '15000',
            },
            state: {
                default: 'NC',
            },
            labelStates: {
                default: 'State:',
            },
            labelDebtAmount: {
                default: 'Amount of Debt:',
            },
            headline: {
                default: 'Partners in your area:',
            },
            buttonText: {
                default: "Let's Go",
            },
            apiResponse: {
                default: false,
            },
            preprimePartnerType: {
                default: 'Debt Consolidation',
            },
            contactBtnText: {
                default: 'Contact',
            },
            hideHdltgp: {
                default: false,
            },
        },
        data() {
            return {
                Amount: this.amount,
                State: this.state,
                ApiResponse: {},
                StateList: States.StateList,
                ButtonText: this.buttonText,
                isActive: false,
                ShowLoader: false,
                PrePrimeType: 'debt-relief',
                Vertical: 'debt relief',
                Placement: 'debt-relief-landing-v2',
                SessionId: SessionIdHelper.getSession(),
                PreprimePartnerType: this.preprimePartnerType,
                isFormChanged: true,
                LeadGuid: null,
                isSendLead: true,
            };
        },
        computed: {
            SelectedState() {
                return find(this.StateList, (element) => {
                    if (element.value === this.State) {
                        return element;
                    }
                    return false;
                }).text;
            },
        },
        watch: {
            State() {
                this.isFormChanged = true;
            },
            Amount() {
                this.isFormChanged = true;
            },
        },
        mounted() {
            const state = QueryStringHelper.getQueryStringParam('state');
            const placement = QueryStringHelper.getQueryStringParam('placement');
            const qfId = QueryStringHelper.getQueryStringParam('qfid');
            this.LeadGuid = qfId;
            this.isSendLead = !qfId; // don't send lead when qfid exist in query param
            this.Placement = placement || this.Placement;
            this.State = state || this.State;
            const requestData = {
                amount: this.Amount,
                state: this.State,
                vertical: this.Vertical,
                placement: this.Placement,
                qFormId: qfId || null,
            };
            this.getDebtReliefDetails(requestData);
            if ('scrollRestoration' in history) {
                history.scrollRestoration = 'manual';
            }
            const url = window.location.href;
            if (url.indexOf('#') < 0) {
                window.location.replace(`${url}#`);
            } else {
                window.location.replace(url);
            }
        },
        methods: {
            getDebtReliefDetails(data) {
                this.ShowLoader = false;
                let datas = data;
                if (!data) {
                    datas = {
                        amount: this.Amount,
                        state: this.State,
                        vertical: this.Vertical,
                        placement: this.Placement,
                    };
                }
                return getPrePrimeDetails(this.SuccessCallback, this.PrePrimeType, datas);
            },
            getDebtReliefDetailsWithModelChange() {
                // Call API only when values are changed from 'DebtReliefBanner'.
                this.getDebtReliefDetails();
                this.isButtonClicked();
            },
            SuccessCallback(response) {
                this.ShowLoader = true;
                if (this.ShowLoader) {
                    if (this.isFormChanged && this.isSendLead) {
                        this.isFormChanged = false;
                        this.makePrePrimeLeadCall();
                    }
                    this.ApiResponse = response;
                }
            },
            makePrePrimeLeadCall() {
                const storageKey = 'debt-relief-lead';
                const expiration = 60 * 60 * 1000;
                const dataFromStore = appStorage.get(storageKey);
                if (dataFromStore) {
                    if (dataFromStore.State === this.State && dataFromStore.Amount === this.Amount) {
                        this.LeadGuid = dataFromStore.LeadGuid;
                        return;
                    }
                }
                this.LeadGuid = SessionIdHelper.generateGuid();
                const data = {
                    state: this.State,
                    stateName: this.SelectedState,
                    amount: this.Amount,
                    vertical: this.Vertical,
                    placement: this.Placement,
                    guid: this.LeadGuid,
                    product: 'debtrelief',
                };
                appStorage.set(storageKey, { State: this.State, Amount: this.Amount, LeadGuid: this.LeadGuid }, expiration);
                postPrePrimeLead(data);
            },
            showDropDownOption() {
                this.isActive = !this.isActive;
            },
            isButtonClicked() {
                TrackDataHelper.setMany(this.trackInputsInDebtRelief(), 'debtReliefInputs');
                AnalyticsHelper.track('Preprime Form Started', TrackDataHelper.get('debtReliefInputs'));
            },
            getDetails() {
                const target = document.getElementById('medium-bullseye');
                ScrollToElement.scrollTo(target);
                this.getDebtReliefDetails();
            },
        },
    };
</script>
<style src="../../assets/styles/common.scss" lang="scss"></style>
<!-- Below main.scss file is common for "Debt Relief & Debt Relief V2" Calculator. -->
<style src="./main.scss" lang="scss"></style>
